import React, {useEffect, useRef, useState} from "react";
import {instanceMob} from "../../../utils/utils";
import useLocationStore from "../config/use-location-store";
import {useNavigate} from "react-router-dom";

const StockContainer = () => {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [stock, setStock] = useState([]);
    const [originalStock, setOriginalStock] = useState([]);
    const [loading, setLoading] = useState(true);
    const dropdownRef = useRef(null);
    const {selectedLocation} = useLocationStore();

    const handleFilter = (filterType) => {
        let sortedStock = [...originalStock];

        switch (filterType) {
            case "desc":
                sortedStock.sort((a, b) => b.quantity - a.quantity);
                break;
            case "asc":
                sortedStock.sort((a, b) => a.quantity - b.quantity);
                break;
            default:
                sortedStock = [...originalStock];
        }

        setStock(sortedStock);
        setIsOpen(false);
    };

    useEffect(() => {
        if (!selectedLocation?.id) return;

        setLoading(true);
        instanceMob
            .get(`/admin/accounting/stock/list?location_id=${selectedLocation.id}`)
            .then((res) => {
                if (res?.data) {
                    setStock(res.data);
                    setOriginalStock(res.data);
                } else {
                    setStock([]);
                    setOriginalStock([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching stock:", error);
                setStock([]);
                setOriginalStock([]);
            })
            .finally(() => setLoading(false));
    }, [selectedLocation]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className={`accounting-dashboard-stock-container d-flex flex-column p-3 py-4 pe-2 ${loading ? "skeleton" : ""}`}>
            <div className="d-flex flex-row gap-2 align-items-center justify-content-between">
                <div className="dropdown" ref={dropdownRef}>
                    <button
                        className="btn dropdown-toggle px-1"
                        type="button"
                        onClick={() => setIsOpen((prev) => !prev)}
                    >
                        Stock
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M11.8079 14.7695L8.09346 10.3121C7.65924 9.79109 8.02976 9 8.70803 9L15.292 9C15.9702 9 16.3408 9.79108 15.9065 10.3121L12.1921 14.7695C12.0921 14.8895 11.9079 14.8895 11.8079 14.7695Z"
                                fill="#222222"
                            />
                        </svg>
                    </button>
                    <ul className={`dropdown-menu p-2 ${isOpen ? "show" : ""}`}>
                        <li>
                            <button
                                className="dropdown-item mb-1 btn-link"
                                onClick={() => handleFilter("all")}
                            >
                                Todos
                            </button>
                        </li>
                        <li>
                            <button
                                className="dropdown-item mb-1 btn-link"
                                onClick={() => handleFilter("desc")}
                            >
                                Mayor a menor
                            </button>
                        </li>
                        <li>
                            <button
                                className="dropdown-item mb-1 btn-link"
                                onClick={() => handleFilter("asc")}
                            >
                                Menor a mayor
                            </button>
                        </li>
                    </ul>
                </div>

                <div className="accounting-dashboard-stock-label-action d-flex align-items-center" onClick={() => {navigate("/accounting/inventory-movement")}}>
                    Ir a inventario
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path
                            d="M18 12L18.7071 12.7071L19.4142 12L18.7071 11.2929L18 12ZM6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13L6 12L6 11ZM14 16L14.7071 16.7071L18.7071 12.7071L18 12L17.2929 11.2929L13.2929 15.2929L14 16ZM18 12L18.7071 11.2929L14.7071 7.29289L14 8L13.2929 8.70711L17.2929 12.7071L18 12ZM18 12L18 11L6 11L6 12L6 13L18 13L18 12Z"
                            fill="#9DACBD"
                        />
                    </svg>
                </div>
            </div>

            <div className={`accounting-dashboard-stock-table pe-2 d-flex flex-column ${loading ?? "skeleton"}`}>
                {loading ? (
                    [...Array(3)].map((_, i) => (
                        <div
                            key={i}
                            className="d-flex justify-content-between align-items-center py-3 px-1 border-bottom"
                        >
                            <div className="accounting-dashboard-stock-table-label w-50 skeleton rounded"></div>
                            <div className="accounting-dashboard-stock-table-label w-25 skeleton rounded"></div>
                        </div>
                    ))
                ) : stock.length > 0 ? (
                    stock.map((item, idx) => (
                        <div
                            key={idx}
                            className="d-flex justify-content-between align-items-center py-3 px-1 border-bottom"
                        >
                            <span className="accounting-dashboard-stock-table-label">{item.name}</span>
                            <span className="accounting-dashboard-stock-table-label">{item.quantity}</span>
                        </div>
                    ))
                ) : (
                    <div className="accounting-dashboard-stock-table-label text-center py-3">
                        No hay productos disponibles
                    </div>
                )}
            </div>
        </div>
    );
};

export default StockContainer;
